<script lang="ts" setup>

// import Button from "primevue/button"

// const props = defineProps<{}>()


const pageStore = usePageStore();

function inverterTelaMaximizada() {
  if (pageStore.maximized) {
    pageStore.maximized = false
    useSetFullScreen(false)
  } else {
    pageStore.maximized = true
    useSetFullScreen(true)
  }
}



</script>

<template>
  
  <Button icon="pi pi-arrow-left" rounded class="shadow-5"/>


</template>



<style></style>